module.exports = __webpack_public_path__ + "img/map-hq-mobile.80eb768e.jpg";